/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { useLabels } from '@/hooks/useLabels';
import { Checkmark, Close, Text } from '@az/starc-ui';

const labelMap = {
  recommendProduct: 'label_reviews_customerRecommendsProduct',
  doesNotRecommentProduct: 'label_reviews_customerDoesNotRecommendProduct',
};

type RecommendationStatusProps = {
  recommend: boolean;
  textClassName?: string;
};

export const RecommendationStatus = ({ recommend, textClassName }: RecommendationStatusProps) => {
  const labels = useLabels(labelMap);
  return (
    <FlexGrid alignItems="center" gap={2} padding={4}>
      {recommend ? (
        <>
          <Checkmark width={20} height={20} color="#F26D0D" data-testid="recommended-icon" />
          <Text
            as="p"
            attributes={{ 'data-testid': 'recommended' }}
            weight="bold"
            className={textClassName}
            color="on-secondary"
          >
            {labels.recommendProduct}
          </Text>
        </>
      ) : (
        <>
          <Close width={20} height={20} color="#B30000" data-testid="not-recommended-icon" />
          <Text
            as="p"
            attributes={{ 'data-testid': 'notRecommended' }}
            weight="bold"
            className={textClassName}
            color="on-secondary"
          >
            {labels.doesNotRecommentProduct}
          </Text>
        </>
      )}
    </FlexGrid>
  );
};
